import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import { Box } from 'rebass/styled-components';
import { userSelector } from 'redux/selectors';
import { usePublicAgent } from './hooks/usePublicAgent';
import { SharedAgentConfig } from './sharedAgentConfig';
import { SharedAgent } from './sharedAgent';

const PublicAgent = () => {
  const location = useLocation();
  const user = useSelector(userSelector);
  const isAuthenticated = !!user?.id;

  // All hooks must be called before any conditional returns
  const { isLoading, error, agentId } = usePublicAgent();

  const showQueryParamsSection = !agentId;

  // Check for collection_id in query params
  const urlParams = new URLSearchParams(window.location.search);
  const collectionId = urlParams.get('collection_id');

  // Redirect to 404 if no collection_id and user is not authenticated
  if (!collectionId && !isAuthenticated) {
    return <Redirect to="/not-found" />;
  }

  // Redirect to login if not authenticated, preserving return URL
  if (!isAuthenticated && showQueryParamsSection) {
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: location },
        }}
      />
    );
  }

  return (
    <Box>
      {showQueryParamsSection && <SharedAgentConfig />}
      {!showQueryParamsSection && <SharedAgent isLoading={isLoading} error={error} />}
    </Box>
  );
};

export default PublicAgent;
